import {ReactNode, useRef} from "react";
import CheckBox from "../../../components/Checkbox";
import styled from "@emotion/styled";
import {usePopup} from "../../../../atom/simpleCert";

const Box = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    line-height: normal;
    margin-top: 8px;
    flex-wrap: wrap;

    &last-child {
        padding-bottom: 50px;
    }

    @media screen and (min-height: 800px) {
        margin-top: 12px;
    }    
`;

const Button = styled.button`
    height: 23px;
    line-height: 1;
    margin-left: auto;
    background: none;
    border: none;
    font-size: 12px;
    color: #333;
    padding: 0 5px;
    text-align: right;
    cursor: pointer;
`;

const ButtonText = styled.span`
    color: #1f1f1f;
    font-size: 14px;
    margin-left: 8px;
    text-decoration: underline;
    text-underline-position: under;
`;

export interface AgreementProps {
    text: string;
    content?: ReactNode;
}

export default function Agreement({text, content}: AgreementProps) {
    const ref = useRef<HTMLInputElement>(null);
    const popup = usePopup();

    const open = () => {
        popup(content,
            () => {

            })
    };

    return (
        <Box>
            <CheckBox label={text} ref={ref} isRequired/>
            <Button onClick={open}>
                <ButtonText>보기</ButtonText>
            </Button>
        </Box>
    );
}